var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.suppliers),function(supplier,index){return _c('TransactionItem',{key:index,attrs:{"amount":supplier.total,"percent":_vm.getPercent(supplier.total, _vm.total_consumed),"operator":supplier.name,"image":_vm.getImageLink(supplier.image)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }